import XeroSerializer from './base';

export default class Batch extends XeroSerializer {
  normalize(modelClass, payload) {
    payload.totalAmount = ((payload.totalAmount ?? 0) / 100).toFixed(2);
    payload.piaAmount = ((payload.piaAmount ?? 0) / 100).toFixed(2);
    return super.normalize(...arguments);
  }

  serialize() {
    let hash = super.serialize(...arguments);
    hash.totalAmount = Math.round(hash.totalAmount * 100);
    hash.piaAmount = Math.round(hash.piaAmount * 100);
    return hash;
  }
}
